export default __webpack_public_path__ + "static/media/icon-non-favorite.21b2d660.svg";